import React, {useState, useEffect, useRef} from 'react';
import TeamInvitationForm from './TeamInvitationForm.mjs';
import TeamInvitationsList from './TeamInvitationsList.mjs';
import TeamOutsideInvitationsList from './TeamOutsideInvitationsList.mjs';
import TeamJoinRequestsList from './TeamJoinRequestsList.mjs';
import TeamMembershipDefaultMessage from './TeamMembershipDefaultMessage.mjs';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function TeamNewMembersCard({team, show_invitations}) 
{
    const { team_member_role, team_invitations_list, team_join_requests_list, team_outside_invitations_list } = useCTAL();
    
    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_invite_user] = useState('invitation'); //looks backward, but it's not 
    const [img_invitations] = useState('request'); 
    
    const [img_invite_user_file, setImgInviteUserFile]  = useState(img_loc + img_invite_user + img_sel + img_ext); 
    const [img_invitations_file, setImgInvitationsFile] = useState(img_loc + img_invitations + img_ext); 
   
    const [member_display_type, setMemberDisplayType] = useState("invite-user");
    const [member_display, setMemberDisplay] = useState(<> <TeamInvitationForm team_id={team.TeamID} /> </>); //HERE
    const [admin_message_display, setAdminMessageDisplay] = useState(<></>); 

    const admin_message_style = { color: 'red' };

    const tooltipRef_invite = useRef(null);
    const tooltipRef_view   = useRef(null);

    useEffect(() => {
        const tooltip_invite = new window.bootstrap.Tooltip(tooltipRef_invite.current, { container: 'body', trigger: 'hover' });
        const tooltip_view   = new window.bootstrap.Tooltip(tooltipRef_view.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_invite.dispose();
            tooltip_view.dispose();
        };
    }, []);
    
    useEffect(() =>
    {
        if (!team) return;

        if (team_member_role == "Admin") setAdminMessageDisplay(<></>);
        else setAdminMessageDisplay(<><span style={admin_message_style}><small>Modifying Invitations requires Team Admin privileges</small></span></>)
    }, [team]);

    useEffect(() =>
    {
        if (show_invitations) show_member_display("team-invitations");
    }, []); //Call once

    if (DEBUG) return;

    const show_member_display = (md_type) => { 
        if (member_display_type == md_type) return;

        setImgInviteUserFile(img_loc  + img_invite_user + img_ext);
        setImgInvitationsFile(img_loc + img_invitations + img_ext);

        switch (md_type)
        {
            case "invite-user":
            default:
                setImgInviteUserFile(img_loc + img_invite_user + img_sel + img_ext);
                setMemberDisplay( <> <TeamInvitationForm team_id={team.TeamID} /> </> ); 
                break;
            case "team-invitations":
                setImgInvitationsFile(img_loc + img_invitations + img_sel + img_ext);
                if ((team_invitations_list.length > 0) || (team_join_requests_list.length > 0) || (team_outside_invitations_list.length > 0))
                    setMemberDisplay( <> {admin_message_display} <TeamInvitationsList team_id={team.TeamID} /> <TeamOutsideInvitationsList team_id={team.TeamID} /> <TeamJoinRequestsList team_id={team.TeamID} /> </> ); 
                else
                    setMemberDisplay( <> <TeamMembershipDefaultMessage /> </> ); 
                break;
        }

        setMemberDisplayType(md_type);
    }
    
    return (
        <>
            <div class="card mt-2">
                <div id="team-member-card-header" class="card-header">
                    <div class="row">
                        <div id="team-member-title" class="col-8 text-start">
                            <a href="#"><img class="card-icon" src="./images/invitation.svg" alt="new-mem" border="0"/></a>
                            <span className="card-sub-title">New Members</span>
                        </div>
                        <div class="col-4 text-end">
                            <a href="#" ref={tooltipRef_invite} data-bs-toggle="tooltip" data-bs-title="Invite Users"     data-bs-delay="750"><img class="card-icon"     src={img_invite_user_file} alt="invite"      border="0" onClick={ () => show_member_display("invite-user") }/></a>
                            <a href="#" ref={tooltipRef_view}   data-bs-toggle="tooltip" data-bs-title="View Invitations" data-bs-delay="750"><img class="card-icon-end" src={img_invitations_file} alt="invitations" border="0" onClick={ () => show_member_display("team-invitations") }/></a>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    {member_display}
                </div>
            </div>
        </>
    );
}

/*
                    <a href="#"><img class="card-icon" src="./images/filter.svg" alt="filter" border="0" onClick={ show_history_filters }/></a>

                    <TeamMemberList team_members_list={team_members_list} />

*/